import React, { useState, useEffect, useCallback } from "react";
import DataFetchHookDomainMonitor from "../../helper/DataFetchHookDomainMonitor";
import { API_BASE_URL } from "../../config/config";
import { Table, PageHeader, Card, Form, Select, Row, Col, Input, Button, Switch, Tag } from "antd";
import { SearchOutlined, CheckCircleOutlined, CloseCircleOutlined, PlusOutlined, PlayCircleOutlined, PauseCircleOutlined } from "@ant-design/icons";
import ExportModalV3 from "../../helper/ExportModalV3";
import CustomPaginationV2 from "../../helper/Table/CustomPaginationV2";
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";
import { API_DOMAIN_MONITOR } from "../../config/config";
import Swal from "sweetalert2";
import EnrollmentModal from "./EnrollmentModal";
import { useHistory } from "react-router-dom";
import { Resizable } from "react-resizable";

const { Option } = Select;

const ResizableTitle = (props) => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={width}
            height={0}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    );
};

const DATA_URL = "/domains";
const DATA_URL_EXPORT = API_BASE_URL + "/v3/domainmonitor/domains/reports";

const DomainList = (props) => {
    const history = useHistory();
    const [{ data, totalResult, isLoading, requestData }, doFetch, setRequestData] = DataFetchHookDomainMonitor(
        DATA_URL,
        "GET",
        {
            page: 1,
            size: 20,
            order: "DESC",
            sort_field: "created_at",
        }
    );

    const [currentPage, setCurrentPage] = useState(1);
    const { t = (key) => key } = props;
    const [toggleLoading, setToggleLoading] = useState({});
    const [isEnrollmentModalVisible, setIsEnrollmentModalVisible] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);

    const [form] = Form.useForm();

    const formValInit = useCallback(() => {
        form.setFieldsValue({
            domain: "",
            name: "",
            status: "",
            monitoring_status: "",
            industry: "",
            business_type: "",
            founded: "",
            created_by: "",
            owner: "",
            order: "DESC",
            sort_field: "created_at",
        });
    }, [form]);

    useEffect(() => {
        formValInit();
    }, [formValInit]);


    

    const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
        var orderBy = 'ASC';
        if (sorter.order === 'descend') {
            orderBy = 'DESC';
        }
        var sortField = 'created_at';
        if (sorter.field !== undefined) {
            sortField = Array.isArray(sorter.field) ? sorter.field[1] : sorter.field;
        }
        var p = pagination.current;
        if (Object.keys(sorter).length > 0 && requestData.sort_field !== sortField) {
            p = 1;
            setCurrentPage(1);
        }

        setRequestData({ ...requestData, order: orderBy, sort_field: sortField, page: p, size: pagination.pageSize });
    };


    const onFinish = () => {
        const sanitizeInput = (input) => {
            if (!input) return null;
            return input.trim().replace(/[<>]/g, ''); // Remove potential XSS characters
        };
        let searchData = {
            domain: form.getFieldValue('domain') ? sanitizeInput(form.getFieldValue('domain')) : null,
            name: form.getFieldValue('name') ? sanitizeInput(form.getFieldValue('name')) : null,
            status: form.getFieldValue('status') ? form.getFieldValue('status') : null,
            monitoring_status: form.getFieldValue('monitoring_status') ? form.getFieldValue('monitoring_status') : null,
            industry: form.getFieldValue('industry') ? sanitizeInput(form.getFieldValue('industry')) : null,
            business_type: form.getFieldValue('business_type') ? sanitizeInput(form.getFieldValue('business_type')) : null,
            founded: form.getFieldValue('founded') ? parseInt(form.getFieldValue('founded')) : null,
            // "Created By" (creator name) and "Belongs To" (owner name or email) searches.
            created_by: form.getFieldValue('created_by') ? sanitizeInput(form.getFieldValue('created_by')) : null,
            owner: form.getFieldValue('owner') ? sanitizeInput(form.getFieldValue('owner')) : null,
        };

        setCurrentPage(1);
        setRequestData({ ...requestData, ...searchData, page: 1 });
    };

    const clearAll = () => {
        setCurrentPage(1);
        setRequestData({
            ...requestData,
            domain: null,
            name: null,
            status: null,
            monitoring_status: null,
            industry: null,
            business_type: null,
            founded: null,
            created_by: null,
            owner: null,
            page: 1
        });
        form.resetFields();
    };

    const handleToggleMonitoring = async (domainId, currentStatus) => {
        const isActive = currentStatus !== 'active';
        const endpoint = isActive ? 'start' : 'stop';

        const result = await Swal.fire({
            title: t("domain_monitor.confirm_action"),
            text: isActive ? t("domain_monitor.start_monitoring") : t("domain_monitor.stop_monitoring"),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t("domain_monitor.yes_proceed"),
            cancelButtonText: t("domain_monitor.cancel")
        });

        if (result.isConfirmed) {
            setToggleLoading({ ...toggleLoading, [domainId]: true });
            try {
                await axios.patch(
                    `${API_DOMAIN_MONITOR}/v1/domains/${domainId}/${endpoint}`,
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + Cookies.get("dm_token"),
                        }
                    }
                );

                Swal.fire(t("domain_monitor.success"), t("domain_monitor.monitoring_updated"), 'success');
                doFetch(DATA_URL + "?" + moment().unix());
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: t("domain_monitor.error"),
                    text: error.response?.data?.message || error.message || t("domain_monitor.unexpected_error")
                });
            } finally {
                setToggleLoading({ ...toggleLoading, [domainId]: false });
            }
        }
    };

    const getStatusBadge = (status) => {
        const config = {
            active: { color: "success", icon: <CheckCircleOutlined /> },
            inactive: { color: "default", icon: <CloseCircleOutlined /> }
        };

        const { color, icon } = config[status] || config.inactive;

        return (
            <Tag color={color} icon={icon}>
                {status ? t(`domain_monitor.${status}`) : t("domain_monitor.unknown")}
            </Tag>
        );
    };

    const handleEnrollmentModalClose = useCallback(() => {
        setIsEnrollmentModalVisible(false);
    }, []);

    const [columns, setColumns] = useState([
        {
            dataIndex: "domain",
            key: "domain",
            title: t("domain_monitor.domain_name"),
            width: 250,
            ellipsis: true,
            sorter: true
        },
        {
            dataIndex: "name",
            key: "name",
            title: t("domain_monitor.business_name"),
            width: 200,
            ellipsis: true,
            sorter: true
        },
        {
            dataIndex: ["web_presence", "industry"],
            key: "industry",
            title: t("domain_monitor.industry"),
            width: 150,
            ellipsis: true,
            sorter: true
        },
        {
            dataIndex: ["web_presence", "businessType"],
            key: "business_type",
            title: t("domain_monitor.business_type"),
            width: 150,
            ellipsis: true,
            sorter: true
        },
        {
            dataIndex: ["web_presence", "foundedYear"],
            key: "founded",
            title: t("domain_monitor.founded_year"),
            width: 120,
            sorter: true
        },
        {
            // Owner of the domain (Domain Monitor user name, email when no name).
            dataIndex: "ownerName",
            key: "owner",
            title: t("domain_monitor.belongs_to"),
            width: 180,
            ellipsis: true,
            render: (ownerName) => ownerName || "-"
        },
        {
            // Who added the domain (name snapshot; "-" for domains created before tracking).
            dataIndex: ["createdBy", "name"],
            key: "created_by",
            title: t("domain_monitor.created_by"),
            width: 160,
            ellipsis: true,
            render: (name) => name || "-"
        },
        {
            dataIndex: "status",
            key: "status",
            title: t("domain_monitor.status"),
            width: 120,
            render: (status) => getStatusBadge(status)
        },
        {
            dataIndex: "monitoringStatus",
            key: "monitoring_status",
            title: t("domain_monitor.monitoring_status"),
            width: 150,
            fixed: "right",
            render: (status, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Switch
                        checked={status === "active"}
                        loading={toggleLoading[record.id]}
                        onChange={() => handleToggleMonitoring(record.id, status)}
                        checkedChildren={t("domain_monitor.active")}
                        unCheckedChildren={t("domain_monitor.paused")}
                    />
                </div>
            )
        },
        {
            dataIndex: "action",
            key: "action",
            title: t("domain_monitor.view_details"),
            width: 120,
            fixed: "right",
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        if (!record?.id) {
                            console.error("Missing record.id", record);
                            return;
                        }
                        history.push(`/domain/${record.id}`);
                    }}
                >
                    {t("domain_monitor.view_details")}
                </Button>
            )
        }
    ]);

    const mergeColumns = columns.map((col, index) => ({
        ...col,
        onHeaderCell: (column) => ({
            width: column.width,
            onResize: (_, { size }) => {
                const newColumns = [...columns];
                newColumns[index] = { ...newColumns[index], width: size.width };
                setColumns(newColumns);
            },
        }),
    }));

    const exportHeaders = [
        { label: t("domain_monitor.export_id"), key: "id" },
        { label: t("domain_monitor.domain_name"), key: "domain" },
        { label: t("domain_monitor.name"), key: "name" },
        { label: t("domain_monitor.status"), key: "status" },
        { label: t("domain_monitor.monitoring_status"), key: "monitoringStatus" },
        // Was "web_presence.businessName" — the Industry column exported the business name.
        { label: t("domain_monitor.industry"), key: "web_presence.industry" },
        { label: t("domain_monitor.business_type"), key: "web_presence.businessType" },
        { label: t("domain_monitor.founded"), key: "web_presence.foundedYear" },
        // Same columns as the page: owner and creator.
        { label: t("domain_monitor.belongs_to"), key: "ownerName" },
        { label: t("domain_monitor.created_by"), key: "createdBy.name" },
        { label: t("domain_monitor.recommendation"), key: "web_presence.recommendation" },
        { label: t("domain_monitor.last_checked"), key: "lastCheckedAt" },
        { label: t("domain_monitor.export_created_at"), key: "createdAt" }
    ];

    const handleEnrollmentSuccess = () => {
        doFetch(DATA_URL + "?" + moment().unix());
    };

    const getSelectedDomains = () => {
        return data.datalist?.filter(item => selectedRowKeys.includes(item.id)) || [];
    };

    const canStartMonitoring = () => {
        const selected = getSelectedDomains();
        return selected.length > 0 && selected.some(item => item.monitoringStatus !== 'active');
    };

    const canStopMonitoring = () => {
        const selected = getSelectedDomains();
        return selected.length > 0 && selected.some(item => item.monitoringStatus === 'active');
    };

    const handleBulkMonitoring = async (action) => {
        const selected = getSelectedDomains();
        const targetDomains = action === 'start'
            ? selected.filter(item => item.monitoringStatus !== 'active')
            : selected.filter(item => item.monitoringStatus === 'active');

        if (targetDomains.length === 0) {
            Swal.fire(
                t('domain_monitor.no_action_needed'),
                t('domain_monitor.no_domains_to_action', { action: action === 'start' ? t('domain_monitor.start') : t('domain_monitor.stop') }),
                'info'
            );
            return;
        }

        const result = await Swal.fire({
            title: t('domain_monitor.confirm_bulk_action'),
            text: t('domain_monitor.bulk_action_confirm', {
                action: action === 'start' ? t('domain_monitor.start') : t('domain_monitor.stop'),
                count: targetDomains.length
            }),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('domain_monitor.yes_proceed'),
            cancelButtonText: t('domain_monitor.cancel')
        });

        if (result.isConfirmed) {
            setBulkActionLoading(true);
            try {
                const ids = targetDomains.map(domain => domain.id);

                await axios.patch(
                    `${API_DOMAIN_MONITOR}/v1/domains/bulk/${action}`,
                    { ids },
                    {
                        headers: {
                            Authorization: "Bearer " + Cookies.get("dm_token"),
                        }
                    }
                );

                Swal.fire({
                    icon: 'success',
                    title: t('domain_monitor.request_submitted'),
                    text: t('domain_monitor.bulk_action_success', {
                        action: action === 'start' ? t('domain_monitor.start') : t('domain_monitor.stop'),
                        count: targetDomains.length
                    }),
                    showConfirmButton: true
                });
                setSelectedRowKeys([]);
                doFetch(DATA_URL + "?" + moment().unix());
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: t('domain_monitor.error'),
                    text: error.response?.data?.message || error.message || t('domain_monitor.unexpected_error')
                });
            } finally {
                setBulkActionLoading(false);
            }
        }
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => {
            setSelectedRowKeys(selectedKeys);
        },
    };

    return (
        <>
            <PageHeader
                title={t("domain_monitor.page_title")}
                subTitle={t("domain_monitor.page_subtitle")}
            />
            <Card>
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item
                                name="domain"
                                label={t("domain_monitor.domain_name")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.search_domain_name")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="name"
                                label={t("domain_monitor.name")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.search_name")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="status"
                                label={t("domain_monitor.status")}
                            >
                                <Select
                                    placeholder={t("domain_monitor.select_status")}
                                    allowClear
                                >
                                    <Option value="active">{t("domain_monitor.active")}</Option>
                                    <Option value="inactive">{t("domain_monitor.inactive")}</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="monitoring_status"
                                label={t("domain_monitor.monitoring_status")}
                            >
                                <Select
                                    placeholder={t("domain_monitor.select_monitoring_status")}
                                    allowClear
                                >
                                    <Option value="active">{t("domain_monitor.active")}</Option>
                                    <Option value="inactive">{t("domain_monitor.inactive")}</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item
                                name="industry"
                                label={t("domain_monitor.industry")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.enter_industry")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="business_type"
                                label={t("domain_monitor.business_type")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.enter_business_type")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="founded"
                                label={t("domain_monitor.founded")}
                            >
                                <Input
                                    type="number"
                                    placeholder={t("domain_monitor.enter_year")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="owner"
                                label={t("domain_monitor.belongs_to")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.search_belongs_to")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={6}>
                            <Form.Item
                                name="created_by"
                                label={t("domain_monitor.created_by")}
                            >
                                <Input
                                    placeholder={t("domain_monitor.search_created_by")}
                                    allowClear
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Button onClick={clearAll} style={{ marginRight: 8 }}>
                                {t("domain_monitor.clear_all")}
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SearchOutlined />}
                            >
                                {t("domain_monitor.search")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Card style={{ marginTop: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setIsEnrollmentModalVisible(true)}
                        >
                            {t("domain_monitor.add_new_merchant")}
                        </Button>
                        <span style={{ fontWeight: 500, marginLeft: 8 }}>
                            {t('domain_monitor.selected_count', { count: selectedRowKeys.length })}
                        </span>
                        <Button
                            icon={<PlayCircleOutlined />}
                            disabled={!canStartMonitoring()}
                            loading={bulkActionLoading}
                            onClick={() => handleBulkMonitoring('start')}
                        >
                            {t('domain_monitor.start_monitoring_btn')}
                        </Button>
                        <Button
                            icon={<PauseCircleOutlined />}
                            disabled={!canStopMonitoring()}
                            loading={bulkActionLoading}
                            onClick={() => handleBulkMonitoring('stop')}
                        >
                            {t('domain_monitor.stop_monitoring_btn')}
                        </Button>
                    </div>
                    <ExportModalV3
                        t={t}
                        export_header={true}
                        keyname="domain_export"
                        title={t("domain_monitor.export_title")}
                        data_url={DATA_URL_EXPORT}
                        data={{ ...requestData, dm_userids: (() => { try { return JSON.parse(Cookies.get("dm_userids") || "[]"); } catch { return []; } })() }}
                        headers={exportHeaders}
                        filename="domains.csv"
                    />
                </div>
                <Table
                    rowSelection={rowSelection}
                    components={{
                        header: {
                            cell: ResizableTitle,
                        },
                    }}
                    columns={mergeColumns}
                    dataSource={data.datalist}
                    loading={isLoading}
                    onChange={handleChange}
                    rowKey="id"
                    scroll={{ x: 1200 }}
                    pagination={CustomPaginationV2({
                        totalResult,
                        currentPage,
                        requestData,
                        setRequestData,
                        setCurrentPage
                    })}
                />
            </Card>
            <EnrollmentModal
                visible={isEnrollmentModalVisible}
                onClose={handleEnrollmentModalClose}
                onSuccess={handleEnrollmentSuccess}
                t={t}
            />
        </>
    );
};

export default DomainList;
